import React, { Component } from "react";
import { Row, Col, Card, CardImg} from "reactstrap";
import { isGamiclub } from "../../constants/isGamiclub.js";
import Swiper from "react-id-swiper";
import { FormattedMessage } from "react-intl";
import TextModalPreview from "./textModalPreview";
import { isGameflares } from "../../constants/productCondition.js";

class TextModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      textmodalData: [],
    };
  }
  onOpenModal = (data) => {
    this.setState({
      textmodalData: data,
      isOpen: true,
    });
  };
  onCloseModal = () => {
    this.setState({
      isOpen: false,
    });
  };
  render() {
    var gameCategoryTitleClass = "game-category-title";
    const gamesParams = {
      direction: 'horizontal',
      slidesPerView: 'auto',
      speed: 500,
    }
    return (
      <div>
        <TextModalPreview
          isModalOpen={this.state.isOpen}
          textmodalData={this.state.textmodalData}
          closeModal={this.onCloseModal}
        />
        {this.props.text.map((data) => (
          <div key={data.id}>
            <Row>
              <Col xs="12" className="game-related-container">
                <div className="game-related-top">
                  <div
                    className="game-category"
                    style={
                      isGamiclub ? { borderBottom: "1px solid green" } : isGameflares ? { borderBottom: "1px solid #FF394B" } :  null
                    }
                  >
                    <h2
                      style={
                        isGamiclub
                          ? { color: "white", backgroundColor: "green" }
                          :isGameflares ?
                          { color: "white", backgroundColor: "#FF394B" }
                          : null
                      }
                      className={gameCategoryTitleClass}
                    >
                      <i className="fa fa-sticky-note-o" aria-hidden="true"></i>
                      <FormattedMessage
                        id={data.categoryName}
                        defaultMessage={data.categoryName}
                      />
                    </h2>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="game-list-row">
              <Col xs="12">
                <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                  {data.tips.map((value) => (
                    <div className="swiper-wallpaper-card" key={value.id}>
                      <Card
                        className={`wallpaper-card ${isGameflares ? 'wallpaper-card-gameflares':''}`}
                        onClick={() => this.onOpenModal(value)}
                      >
                        <div className="wallpaper-card-inner">
                          <div className="wallpaper-thumb-wrap">
                            <CardImg
                              className="wallpaper-thumb"
                              top
                              width="auto"
                              height="150"
                              src={value.img}
                            />
                          </div>
                          <span className="wallpaper-title">{value.title}</span>
                        </div>
                      </Card>
                    </div>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    );
  }
}
export default TextModal;



// WEBPACK FOOTER //
// ./src/components/TextModal/textModal.js